function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.999 5V1.5h-2.5a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5H12.5A1.5 1.5 0 0014 12V6.5h-3.502a1.5 1.5 0 01-1.5-1.5zm1 0V1.75l3.75 3.75h-3.25a.5.5 0 01-.5-.5zM3 4.5a1 1 0 011-1V12a2.5 2.5 0 002.5 2.5H12a1 1 0 01-1 1H6.556A3.556 3.556 0 013 11.944V4.5z",
  fill: "#6264A7"
});

function SvgFilledFileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFilledFileIcon;